// Case sensitive. needs to be the same as auth0 dashboard
export const enum ROLES {
    ADMINISTRATIVE_ASSISTANT = "Administrative Assistant",
    BANKRUPTCY_AGENT = "Bankruptcy Agent",
    COMMUNITY_MANAGER = "Community Manager",
    CORP_TAX_AGENT = "Corp + Tax Agent",
    CREDIT_AGENT = "Credit Agent",
    CREDIT_AGENT_DEVICE = "Credit Agent Device",
    CREDIT_SALES_MANAGER = "Credit Sales Manager",
    CUSTOMER_SERVICE_MANAGER = "Customer Service Manager",
    CUSTOMER_SERVICE_REP = "Customer Service Rep",
    DOC_COLLECTION = "Doc Collection",
    FUNDING_ASSISTANT = "Funding Assistant",
    FUNDING_MANAGER = "Funding Manager",
    FRONT_DESK = "Front Desk",
    HR_MANAGER = "HR Manager",
    LEGAL = "Legal",
    LIFE_INSURANCE_AGENT = "Life Insurance Agent",
    LOAN_OFFICER = "Loan Officer",
    LOAN_PROCESSOR = "Loan Processor",
    MEDIA_MANAGER = "Media Manager",
    OFFICE_MANAGER = "Office Manager",
    OWNER = "Owner",
    PAYMENT_PROCESSOR = "Payment Processor",
    PROCESSING_SPECIALIST = "Processing Specialist",
    QUALITY_CONTROL = "Quality Control",
    REAL_ESTATE_AGENT = "Real Estate Agent",
    REAL_ESTATE_MANAGER = "Real Estate Manager",
    SETTLEMENT_SPECIALIST = "Settlement Specialist",
    SUPER_ADMIN = "Super Admin",
    TELEMARKETER = "Telemarketer",
    TELEMARKETING_MANAGER = "Telemarketing Manager",
    TELEMARKETING_DEVICE = "Telemarketer Device",
}

// Case sensitive. needs to be the same as auth0 dashboard
export enum PERMISSIONS {
    VALIDATE_PROGRAM = "validate:program",
    VALIDATE_SPECIAL_PRICING_PROGRAM = "validate:special_pricing_program",
    READ_PROCESSING_STAGES_TABLE = "read:processing_stages",
    DELETE_PROCESSING_STAGES = "delete:processing_stage",
    READ_READY_TO_SETTLE_STAGES_TABLE = "read:ready_to_settle_stages",
    COMPLETE_READY_TO_SETTLE_STAGES = "complete:ready_to_settle_stage",

    LEAD_ACCESS = "read:lead_tab",
    LEAD_READ = "read:lead",
    LEAD_READ_OWN = "read:lead_own",
    LEAD_CREATE = "create:lead",
    LEAD_UPDATE = "update:lead",
    LEAD_DELETE = "delete:lead",
    LEAD_IMPORT = "create:lead_import",
    LEAD_UPDATE_FLAG = "update:lead_flag",
    LEAD_UPDATE_UNFLAG = "update:lead_unflag",
    LEAD_UPDATE_CHECKMARK = "update:lead_checkmark",
    LEAD_UPDATE_UNCHECKMARK = "update:lead_uncheckmark",
    LEAD_UPDATE_AGENT = "update:lead_agent",
    LEAD_UPDATE_TELEMARKETER = "update:lead_telemarketer",
    LEAD_UPDATE_TELEMARKETER_OWN = "update:lead_telemarketer_own",
    LEAD_UPDATE_CUSTOMER_SERVICE_REP = "update:lead_customer_service_rep",
    LEAD_UPDATE_CUSTOMER_SERVICE_REP_OWN = "update:lead_customer_service_rep_own",
    LEAD_UPDATE_AGENT_OWN = "update:lead_agent_own",
    LEAD_UPDATE_RE_AGENT = "update:lead_re_agent",
    LEAD_UPDATE_RE_AGENT_OWN = "update:lead_re_agent_own",
    LEAD_UPDATE_FUNDING_AGENT = "update:lead_funding_agent",
    LEAD_UPDATE_FUNDING_AGENT_OWN = "update:lead_funding_agent_own",
    LEAD_UPDATE_LOAN_OFFICER = "update:lead_loan_officer",
    LEAD_UPDATE_LOAN_OFFICER_OWN = "update:lead_loan_officer_own",
    LEAD_DETAILS = "read:lead_details",
    LEAD_UPDATE_CONVERT = "update:lead_convert",
    LEAD_READ_OVERALL = "read:lead_overall",
    LEAD_UPDATE_OVERALL = "update:lead_overall",
    LEAD_READ_ADS = "read:lead_ads",
    LEAD_UPDATE_ADS = "update:lead_ads",
    LEAD_CREATE_CREDIT_SCORES = "create:lead_credit_scores",
    LEAD_UPDATE_CREDIT_SCORES = "update:lead_credit_scores",
    LEAD_DELETE_CREDIT_SCORES = "delete:lead_credit_scores",
    LEAD_READ_PROGRAM = "read:lead_program",
    LEAD_CREATE_PROGRAM = "create:lead_program",
    LEAD_READ_QUOTES = "read:lead_quotes",
    LEAD_CREATE_QUOTES = "create:lead_quotes",
    LEAD_DELETE_QUOTES = "delete:lead_quotes",
    LEAD_UPDATE_QUOTES = "update:lead_quotes",
    LEAD_UPDATE_PAYMENT_METHODS = "update:lead_payment_methods",
    // LEAD_UPDATE_PROGRAM_CONTRACT_CLOSED = "update:lead_program_contract_closed",
    // LEAD_UPDATE_PROGRAM_STATUS = "update:lead_program_status",
    // LEAD_READ_PROGRAM_AGENT_FEE = "read:lead_program_agent_fee",
    // LEAD_READ_PROGRAM_PRICE = "read:lead_program_price",
    // LEAD_READ_PROGRAM_INFO = "read:lead_program_info",
    // LEAD_DELETE_PROGRAM = "delete:lead_program",
    LEAD_READ_FINANCIAL = "read:lead_financial",
    LEAD_UPDATE_FINANCIAL = "update:lead_financial",
    LEAD_READ_DOCUMENT = "read:lead_document",
    LEAD_IMPORT_DOCUMENT = "import:lead_document",
    LEAD_DELETE_DOCUMENT = "delete:lead_document",
    LEAD_READ_NOTES = "read:lead_notes",
    LEAD_CREATE_NOTES = "create:lead_notes",
    LEAD_UPDATE_NOTES = "update:lead_notes",
    LEAD_DELETE_NOTES = "delete:lead_notes",
    LEAD_READ_CONVERSATION = "read:lead_conversation",
    LEAD_CREATE_CONVERSATION = "create:lead_conversation",
    LEAD_ACTIVITY_TAB = "read:lead_activity_tab",

    CLIENT_ACCESS = "read:client_tab",
    CLIENT_READ = "read:client",
    CLIENT_READ_OWN = "read:client_own",
    CLIENT_READ_BANKRUPTCY = "read:client_bankruptcy",
    CLIENT_CREATE = "create:client",
    CLIENT_UPDATE = "update:client",
    CLIENT_DELETE = "delete:client",
    CLIENT_IMPORT = "create:client_import",
    CLIENT_UPDATE_TELEMARKETER = "update:client_telemarketer",
    CLIENT_UPDATE_TELEMARKETER_OWN = "update:client_telemarketer_own",
    CLIENT_UPDATE_CUSTOMER_SERVICE_REP = "update:client_customer_service_rep",
    CLIENT_UPDATE_CUSTOMER_SERVICE_REP_OWN = "update:client_customer_service_rep_own",
    CLIENT_UPDATE_AGENT = "update:client_agent",
    CLIENT_UPDATE_AGENT_OWN = "update:client_agent_own",
    CLIENT_UPDATE_RE_AGENT = "update:client_re_agent",
    CLIENT_UPDATE_RE_AGENT_OWN = "update:client_re_agent_own",
    CLIENT_UPDATE_FUNDING_AGENT = "update:client_funding_agent",
    CLIENT_UPDATE_FUNDING_AGENT_OWN = "update:client_funding_agent_own",
    CLIENT_UPDATE_LOAN_OFFICER = "update:client_loan_officer",
    CLIENT_UPDATE_LOAN_OFFICER_OWN = "update:client_loan_officer_own",
    CLIENT_UPDATE_FLAG = "update:client_flag",
    CLIENT_UPDATE_UNFLAG = "update:client_unflag",
    CLIENT_UPDATE_CHECKMARK = "update:client_checkmark",
    CLIENT_UPDATE_UNCHECKMARK = "update:client_uncheckmark",
    CLIENT_ACTIVITY = "read:client_activity",
    CLIENT_DETAILS = "read:client_details",
    CLIENT_PRODUCTION = "read:client_production",
    CLIENT_READ_OVERALL = "read:client_overall",
    CLIENT_UPDATE_OVERALL = "update:client_overall",
    CLIENT_READ_ADS = "read:client_ads",
    CLIENT_UPDATE_ADS = "update:client_ads",
    CLIENT_CREATE_CREDIT_SCORES = "create:client_credit_scores",
    CLIENT_UPDATE_CREDIT_SCORES = "update:client_credit_scores",
    CLIENT_DELETE_CREDIT_SCORES = "delete:client_credit_scores",
    CLIENT_READ_PROGRAM = "read:client_program",
    CLIENT_CREATE_PROGRAM = "create:client_program",
    CLIENT_READ_QUOTES = "read:client_quotes",
    CLIENT_CREATE_QUOTES = "create:client_quotes",
    CLIENT_DELETE_QUOTES = "delete:client_quotes",
    CLIENT_UPDATE_QUOTES = "update:client_quotes",
    CLIENT_UPDATE_PROGRAM_CONTRACT_CLOSED = "update:client_program_contract_closed",
    CLIENT_UPDATE_PROGRAM_STATUS = "update:client_program_status",
    CLIENT_UPDATE_PROGRAM_INFO = "update:client_program_info",
    CLIENT_READ_PROGRAM_AGENT_FEE = "read:client_program_agent_fee",
    CLIENT_READ_PROGRAM_PRICE = "read:client_program_price",
    CLIENT_READ_PROGRAM_INFO = "read:client_program_info",
    CLIENT_DELETE_PROGRAM = "delete:client_program",
    CLIENT_READ_BANKRUPTCY_TAB = "read:client_bankruptcy_tab",
    CLIENT_UPDATE_BANKRUPTCY_TAB = "update:client_bankruptcy_tab",
    CLIENT_READ_PAYMENT = "read:client_payment",
    CLIENT_UNLOCK_PAYMENT_METHODS = "unlock:client_payment_methods",
    CLIENT_UPDATE_PAYMENT_METHODS = "update:client_payment_methods",
    CLIENT_READ_CLIENT_COMMISSIONS = "read:client_commissions",
    CLIENT_UPDATE_CLIENT_COMMISSIONS = "update:client_commissions",
    CLIENT_READ_PAYMENT_TRANSACTIONS = "read:client_payment_transactions",
    CLIENT_CREATE_PAYMENT_TRANSACTIONS = "create:client_payment_transactions",
    CLIENT_UPDATE_PAYMENT_TRANSACTIONS = "update:client_payment_transactions",
    CLIENT_READ_PAYMENT_RE_TRANSACTIONS = "read:client_payment_re_transactions",
    CLIENT_CREATE_PAYMENT_RE_TRANSACTIONS = "create:client_payment_re_transactions",
    CLIENT_UPDATE_PAYMENT_RE_TRANSACTIONS = "update:client_payment_re_transactions",
    CLIENT_DELETE_PAYMENT_RE_TRANSACTIONS = "delete:client_payment_re_transactions",
    CLIENT_UPDATE_PAYMENT_INFO = "update:client_payment_info",
    CLIENT_READ_PAYMENT_FEES = "read:client_payment_fees",
    CLIENT_CREATE_PAYMENT_FEES = "create:client_payment_fees",
    CLIENT_UPDATE_PAYMENT_FEES = "update:client_payment_fees",
    CLIENT_DELETE_PAYMENT_FEES = "delete:client_payment_fees",
    CLIENT_READ_PAYMENT_FEES_TRANSACTIONS = "read:client_payment_fees_transactions",
    CLIENT_CREATE_PAYMENT_FEES_TRANSACTIONS = "create:client_payment_fees_transactions",
    CLIENT_UPDATE_PAYMENT_FEES_TRANSACTIONS = "update:client_payment_fees_transactions",
    CLIENT_READ_FINANCIAL = "read:client_financial",
    CLIENT_UPDATE_FINANCIAL = "update:client_financial",
    CLIENT_READ_REAL_ESTATE = "read:client_real_estate",
    CLIENT_UPDATE_REAL_ESTATE = "update:client_real_estate",
    CLIENT_READ_RE_COMMISSIONS = "read:client_re_commissions",
    CLIENT_UPDATE_RE_COMMISSIONS = "update:client_re_commissions",
    CLIENT_READ_RE_D_COMMISSIONS = "read:client_re_d_commissions",
    CLIENT_UPDATE_RE_D_COMMISSIONS = "update:client_re_d_commissions",
    CLIENT_READ_PROCESSING = "read:client_processing",
    CLIENT_UPDATE_PROCESSING = "update:client_processing",
    CLIENT_READ_PROCESSING_PROCESS = "read:client_processing_process",
    CLIENT_CREATE_PROCESSING_PROCESS = "create:client_processing_process",
    CLIENT_DELETE_PROCESSING_PROCESS = "delete:client_processing_process",
    CLIENT_UPDATE_PROCESSING_PROCESS = "update:client_processing_process",
    CLIENT_READ_PROCESSING_PLATFORM_ACCESS = "read:client_processing_platform_access",
    CLIENT_CREATE_PROCESSING_PLATFORM_ACCESS = "create:client_processing_platform_access",
    CLIENT_DELETE_PROCESSING_PLATFORM_ACCESS = "delete:client_processing_platform_access",
    CLIENT_UPDATE_PROCESSING_PLATFORM_ACCESS = "update:client_processing_platform_access",
    CLIENT_READ_FUNDING = "read:client_funding",
    CLIENT_READ_FUNDING_CREDIT_LINES = "read:client_funding_credit_lines",
    CLIENT_CREATE_FUNDING_CREDIT_LINES = "create:client_funding_credit_lines",
    CLIENT_UPDATE_FUNDING_CREDIT_LINES = "update:client_funding_credit_lines",
    CLIENT_DELETE_FUNDING_CREDIT_LINES = "delete:client_funding_credit_lines",
    CLIENT_READ_FUNDING_BANK_ACCESS = "read:client_funding_bank_access",
    CLIENT_CREATE_FUNDING_BANK_ACCESS = "create:client_funding_bank_access",
    CLIENT_DELETE_FUNDING_BANK_ACCESS = "delete:client_funding_bank_access",
    CLIENT_UPDATE_FUNDING_BANK_ACCESS = "update:client_funding_bank_access",
    CLIENT_READ_TRADELINES = "read:client_tradelines",
    CLIENT_UPDATE_TRADELINES = "update:client_tradelines",
    CLIENT_READ_TRADELINES_TRADELINE = "read:client_tradelines_tradeline",
    CLIENT_CREATE_TRADELINES_TRADELINE = "create:client_tradelines_tradeline",
    CLIENT_DELETE_TRADELINES_TRADELINE = "delete:client_tradelines_tradeline",
    CLIENT_UPDATE_TRADELINES_TRADELINE = "update:client_tradelines_tradeline",
    CLIENT_READ_SETTLEMENTS = "read:client_settlements",
    CLIENT_READ_SETTLEMENTS_SETTLEMENT = "read:client_settlements_settlement",
    CLIENT_CREATE_SETTLEMENTS_SETTLEMENT = "create:client_settlements_settlement",
    CLIENT_DELETE_SETTLEMENTS_SETTLEMENT = "delete:client_settlements_settlement",
    CLIENT_UPDATE_SETTLEMENTS_SETTLEMENT = "update:client_settlements_settlement",
    CLIENT_CREATE_SETTLEMENTS_NOTIFICATION = "create:client_settlements_notification",
    CLIENT_READ_SETTLEMENTS_CREDIT_CARD = "read:client_settlements_credit_card",
    CLIENT_CREATE_SETTLEMENTS_CREDIT_CARD = "create:client_settlements_credit_card",
    CLIENT_DELETE_SETTLEMENTS_CREDIT_CARD = "delete:client_settlements_credit_card",
    CLIENT_UPDATE_SETTLEMENTS_CREDIT_CARD = "update:client_settlements_credit_card",
    CLIENT_READ_ACCOUNTS = "read:client_accounts",
    CLIENT_CREATE_ACCOUNTS = "create:client_accounts",
    CLIENT_DELETE_ACCOUNTS = "delete:client_accounts",
    CLIENT_UPDATE_ACCOUNTS = "update:client_accounts",
    CLIENT_READ_VIOLATIONS = "read:client_violations",
    CLIENT_CREATE_VIOLATIONS = "create:client_violations",
    CLIENT_DELETE_VIOLATIONS = "delete:client_violations",
    CLIENT_UPDATE_VIOLATIONS = "update:client_violations",
    CLIENT_READ_DOCUMENT = "read:client_document",
    CLIENT_IMPORT_DOCUMENT = "import:client_document",
    CLIENT_DELETE_DOCUMENT = "delete:client_document",
    CLIENT_READ_NOTES = "read:client_notes",
    CLIENT_CREATE_NOTES = "create:client_notes",
    CLIENT_DELETE_NOTES = "delete:client_notes",
    CLIENT_UPDATE_NOTES = "update:client_notes",
    CLIENT_READ_CONVERSATION = "read:client_conversation",
    CLIENT_CREATE_CONVERSATION = "create:client_conversation",
    CLIENT_ACTIVITY_TAB = "read:client_activity_tab",

    BUSINESS_ACCESS_TAB = "read:business_tab",
    BUSINESS_READ = "read:business",
    BUSINESS_UPDATE = "update:business",
    BUSINESS_DELETE = "delete:business",
    BUSINESS_CREATE = "create:business",
    BUSINESS_UNLOCK_BANK_INFORMATION = "read:business_bank_information",
    BUSINESS_READ_DOCUMENT = "read:business_document",
    BUSINESS_CREATE_DOCUMENT = "create:business_document",
    BUSINESS_DELETE_DOCUMENT = "delete:business_document",
    BUSINESS_UPDATE_DOCUMENT = "update:business_document",
    BUSINESS_READ_NOTES = "read:business_notes",
    BUSINESS_CREATE_NOTES = "create:business_notes",
    BUSINESS_UPDATE_NOTES = "update:business_notes",
    BUSINESS_DELETE_NOTES = "delete:business_notes",
    BUSINESS_READ_VOE = "read:business_voe",
    CONVERSATION_ACCESS = "read:conversation_tab",
    READ_CONVERSATION = "read:conversation",
    READ_CONVERSATION_OWN = "read:conversation_own",
    UPDATE_CONVERSATION_RESPONSIBLE = "update:conversation_responsible",
    UPDATE_CONVERSATION_WATCHERS = "update:conversation_watchers",

    OPPORTUNITY_ACCESS_TAB = "read:opportunity_tab",
    OPPORTUNITY_CREDIT_REPAIR_READ = "read:opportunity_credit_repair",
    OPPORTUNITY_CREDIT_REPAIR_CREATE = "create:opportunity_credit_repair",
    OPPORTUNITY_CREDIT_REPAIR_UPDATE = "update:opportunity_credit_repair",
    OPPORTUNITY_CREDIT_REPAIR_DELETE = "delete:opportunity_credit_repair",
    OPPORTUNITY_BUYER_READ = "read:opportunity_buyer",
    OPPORTUNITY_BUYER_CREATE = "create:opportunity_buyer",
    OPPORTUNITY_BUYER_UPDATE = "update:opportunity_buyer",
    OPPORTUNITY_BUYER_DELETE = "delete:opportunity_buyer",
    OPPORTUNITY_MORTGAGE_READ = "read:opportunity_mortgage",
    OPPORTUNITY_MORTGAGE_CREATE = "create:opportunity_mortgage",
    OPPORTUNITY_MORTGAGE_UPDATE = "update:opportunity_mortgage",
    OPPORTUNITY_MORTGAGE_DELETE = "delete:opportunity_mortgage",
    OPPORTUNITY_HELOC_READ = "read:opportunity_heloc",
    OPPORTUNITY_HELOC_CREATE = "create:opportunity_heloc",
    OPPORTUNITY_HELOC_UPDATE = "update:opportunity_heloc",
    OPPORTUNITY_HELOC_DELETE = "delete:opportunity_heloc",
    OPPORTUNITY_REFINANCING_READ = "read:opportunity_refinancing",
    OPPORTUNITY_REFINANCING_CREATE = "create:opportunity_refinancing",
    OPPORTUNITY_REFINANCING_UPDATE = "update:opportunity_refinancing",
    OPPORTUNITY_REFINANCING_DELETE = "delete:opportunity_refinancing",
    OPPORTUNITY_SELLER_READ = "read:opportunity_seller",
    OPPORTUNITY_SELLER_CREATE = "create:opportunity_seller",
    OPPORTUNITY_SELLER_UPDATE = "update:opportunity_seller",
    OPPORTUNITY_SELLER_DELETE = "delete:opportunity_seller",

    EMPLOYEE_ACCESS = "read:employee_tab",
    EMPLOYEE_READ = "read:employee",
    EMPLOYEE_READ_NOT_OWN = "read:employee_not_own",
    EMPLOYEE_CREATE = "create:employee",
    EMPLOYEE_DELETE = "delete:employee",
    EMPLOYEE_READ_OVERALL = "read:employee_overall",
    EMPLOYEE_UPDATE_OVERALL = "update:employee_overall",
    EMPLOYEE_READ_CONTACT = "read:employee_contact",
    EMPLOYEE_CREATE_NOTES = "create:employee_notes",
    EMPLOYEE_UPDATE_NOTES = "update:employee_notes",
    EMPLOYEE_DELETE_NOTES = "delete:employee_notes",
    EMPLOYEE_IMPORT_DOCUMENT = "import:employee_document",
    EMPLOYEE_DELETE_DOCUMENT = "delete:employee_document",
    EMPLOYEE_READ_COMMISSIONS = "read:employee_commissions",
    EMPLOYEE_UPDATE_COMMISSIONS = "update:employee_commissions",

    ACTIVITY_ACCESS = "read:activity_tab",

    CAMPAIGN_ACCESS = "read:campaign_tab",
    CAMPAIGN_READ_BULK_MESSAGES = "read:campaign_bulk_messages",
    CAMPAIGN_CREATE_BULK_MESSAGES = "create:campaign_bulk_messages",
    CAMPAIGN_READ = "read:campaign",
    CAMPAIGN_CREATE = "create:campaign",
    CAMPAIGN_DELETE = "delete:campaign",
    CAMPAIGN_UPDATE = "update:campaign",

    USER_ACCESS = "read:user_tab",
    USER_CREATE = "create:user",
    USER_READ = "read:user",
    USER_UPDATE = "update:user",
    USER_DELETE = "delete:user",
    USER_REASSIGN = "reassign:user",
    USER_UPDATE_ROLE_PERMISSIONS = "update:user_role_permissions",
    USER_UPDATE_PASSWORD = "update:user_password",

    CALENDAR_ACCESS = "read:calendar_tab",
    CALENDAR_READ_APPOINTMENTS = "read:calendar_appointments",
    CALENDAR_READ_APPOINTMENTS_OWN = "read:calendar_appointments_own",
    CALENDAR_CREATE_APPOINTMENTS = "create:calendar_appointments",
    CALENDAR_UPDATE_APPOINTMENTS = "update:calendar_appointments",
    CALENDAR_DELETE_APPOINTMENTS = "delete:calendar_appointments",
    CALENDAR_CREATE_APPOINTMENTS_SUPERIOR = "create:calendar_appointments_superior",
    CALENDAR_CREATE_APPOINTMENTS_INFERIOR = "create:calendar_appointments_inferior",
    CALENDAR_READ_APPOINTMENTS_ASSIGNED_BY = "read:calendar_appointments_assigned_by",
    CALENDAR_READ_TASKS = "read:calendar_tasks",
    CALENDAR_READ_TASKS_OWN = "read:calendar_tasks_own",
    CALENDAR_CREATE_TASKS = "create:calendar_tasks",
    CALENDAR_UPDATE_TASKS = "update:calendar_tasks",
    CALENDAR_DELETE_TASKS = "delete:calendar_tasks",
    CALENDAR_CREATE_TASKS_SUPERIOR = "create:calendar_tasks_superior",
    CALENDAR_CREATE_TASKS_INFERIOR = "create:calendar_tasks_inferior",
    CALENDAR_READ_TASKS_ASSIGNED_BY = "read:calendar_tasks_assigned_by",

    SETTINGS_ACCESS = "read:settings_tab",
    SETTINGS_READ_DROPDOWNS = "read:settings_dropdowns",
    SETTINGS_READ_ROUND_ROBIN = "read:settings_round_robin",
    SETTINGS_READ_CREDITORS = "read:settings_creditors",
    SETTINGS_READ_CR_PRICING = "read:settings_cr_pricing",
    SETTINGS_READ_ANUAL_INTEREST = "read:settings_anual_interest",
    SETTINGS_UPDATE_DROPDOWNS = "update:settings_dropdowns",
    SETTINGS_UPDATE_ROUND_ROBIN = "update:settings_round_robin",
    SETTINGS_UPDATE_CREDITORS = "update:settings_creditors",
    SETTINGS_UPDATE_CR_PRICING = "update:settings_cr_pricing",
    SETTINGS_UPDATE_ANUAL_INTEREST = "update:settings_anual_interest",
    SETTINGS_READ_LEGAL_TEXTS = "read:settings_legal_texts",
    SETTINGS_UPDATE_LEGAL_TEXTS = "update:settings_legal_texts",
    SETTINGS_READ_ROLES = "read:settings_roles",
    SETTINGS_UPDATE_ROLES = "update:settings_roles",

    REFERRAL_AGENT_READ = "read:referral_agent",
    REFERRAL_AGENT_CREATE = "create:referral_agent",
    REFERRAL_AGENT_UPDATE = "update:referral_agent",
    REFERRAL_AGENT_DELETE = "delete:referral_agent",

    TUTORIAL_ACCESS = "read:tutorial_tab",
    TUTORIAL_READ = "read:tutorial",
    TUTORIAL_CREATE = "create:tutorial",
    TUTORIAL_UPDATE = "update:tutorial",
    TUTORIAL_DELETE = "delete:tutorial",

    ANALYTICS_ACCESS = "read:analytics_tab",
    ANALYTICS_READ = "read:analytics",
    ANALYTICS_CREATE = "create:analytics",
    ANALYTICS_UPDATE = "update:analytics",
    ANALYTICS_DELETE = "delete:analytics",

    PAYMENTS_ACCESS = "read:payments_tab",
    PAYMENTS_READ = "read:payments",
    PAYMENTS_CREATE = "create:payments",
    PAYMENTS_UPDATE = "update:payments",
    PAYMENTS_DELETE = "delete:payments",

    READ_INQUIRIES_REMOVAL_STAGES = "read:inquiries_removal_stages",
    READ_PAUSE_XP_STAGES_TABLE = "read:pause_xp_stages",
    COMPLETE_PAUSE_XP_STAGES = "complete:pause_xp_stage",

    READ_FIRST_PAYMENT_STAGES = "read:first_payment_stages",
    COMPLETE_FIRST_PAYMENT_STAGES = "complete:first_payment_stage",

    READ_PAID_IN_FULL_DASHBOARD = "read:paid_in_full_dashboard",

    TEAMHUB_ACCESS = "read:teamhub_tab",
    TEAMHUB_TEMPLATES_ACCESS = "read:teamhub_templates",
    TEAMHUB_VIEW_ALL_TEMPLATES = "read:teamhub_all_templates",
    TEAMHUB_CREATE_FOLDERS = "create:teamhub_folders",
    TEAMHUB_EDIT_FOLDERS = "update:teamhub_folders",
    TEAMHUB_DELETE_FOLDERS = "delete:teamhub_folders",
    TEAMHUB_CREATE_SYSTEM_TEMPLATES = "create:teamhub_system_templates",
    TEAMHUB_EDIT_SYSTEM_TEMPLATES = "update:teamhub_system_templates",
    TEAMHUB_DELETE_SYSTEM_TEMPLATES = "delete:teamhub_system_templates",
    TEAMHUB_CREATE_OWN_TEMPLATES = "create:teamhub_own_templates",
    TEAMHUB_EDIT_OWN_TEMPLATES = "update:teamhub_own_templates",
    TEAMHUB_DELETE_OWN_TEMPLATES = "delete:teamhub_own_templates",
    TEAMHUB_CREATE_TEAM_TEMPLATES = "create:teamhub_team_templates",
    TEAMHUB_EDIT_TEAM_TEMPLATES = "update:teamhub_team_templates",
    TEAMHUB_DELETE_TEAM_TEMPLATES = "delete:teamhub_team_templates",

    // Schedule and Holidays module
    TEAMHUB_SCHEDULE_ACCESS = "read:teamhub_schedule_and_holidays",
    TEAMHUB_CALENDAR_READ = "read:teamhub_calendar",
    TEAMHUB_CALENDAR_CREATE = "create:teamhub_calendar",
    TEAMHUB_CALENDAR_UPDATE = "update:teamhub_calendar",
    TEAMHUB_CALENDAR_DELETE = "delete:teamhub_calendar",
    TEAMHUB_SCHEDULES_READ = "read:teamhub_schedules",
    TEAMHUB_SCHEDULES_CREATE = "create:teamhub_schedules",
    TEAMHUB_SCHEDULES_UPDATE = "update:teamhub_schedules",
    TEAMHUB_SCHEDULES_DELETE = "delete:teamhub_schedules",
    TEAMHUB_VACATIONS_READ = "read:teamhub_vacations",
    TEAMHUB_VACATIONS_CREATE = "create:teamhub_vacations",
    TEAMHUB_VACATIONS_UPDATE = "update:teamhub_vacations",
    TEAMHUB_VACATIONS_DELETE = "delete:teamhub_vacations",
    TEAMHUB_HOLIDAYS_READ = "read:teamhub_holidays",
    TEAMHUB_HOLIDAYS_CREATE = "create:teamhub_holidays",
    TEAMHUB_HOLIDAYS_UPDATE = "update:teamhub_holidays",
    TEAMHUB_HOLIDAYS_DELETE = "delete:teamhub_holidays",

    // Attendance
    TEAMHUB_LIVE_ATTENDANCE_ACCESS = "read:teamhub_live_attendance",
    TEAMHUB_TIMECARD_REPORT_ACCESS = "read:teamhub_timecard_report",

    TEAMHUB_TOOLS_ACCESS = "read:teamhub_tools",
    TEAMHUB_TOOLS_RDC_CREDIT_COST_CLOSER = "read:teamhub_tools_rdc_credit_cost_closer",

    // Tickets module
    TEAMHUB_TICKETS_ACCESS = "read:teamhub_tickets",
    TEAMHUB_TICKETS_MANAGE = "update:teamhub_tickets",

    VIEW_CREDIT_SALES_ANALYTICS = "view:credit_sales_analytics",
    VIEW_TELEMARKETING_ANALYTICS = "view:telemarketing_analytics",
    VIEW_RE_COMMISSIONS_ANALYTICS = "view:re_commissions_analytics",
    VIEW_ADS_ANALYTICS = "view:ads_analytics",

    // Shared — Lead & Client
    READ_PROPERTIES = "read:properties",
    CREATE_PROPERTIES = "create:properties",
    UPDATE_PROPERTIES = "update:properties",
    DELETE_PROPERTIES = "delete:properties",
}

/**
 * ACCESS PERMISSIONS ARRAY
 */
export const ACCESS_PERMISSIONS = [
    PERMISSIONS.LEAD_ACCESS,
    PERMISSIONS.CLIENT_ACCESS,
    PERMISSIONS.CONVERSATION_ACCESS,
    PERMISSIONS.EMPLOYEE_ACCESS,
    PERMISSIONS.ACTIVITY_ACCESS,
    PERMISSIONS.CAMPAIGN_ACCESS,
    PERMISSIONS.USER_ACCESS,
    PERMISSIONS.CALENDAR_ACCESS,
    PERMISSIONS.SETTINGS_ACCESS,
    PERMISSIONS.TUTORIAL_ACCESS,
    PERMISSIONS.ANALYTICS_ACCESS,
    PERMISSIONS.TEAMHUB_ACCESS,
];

/**
 * Permissions for Special section
 */
export const SPECIAL_PERMISSIONS = [
    PERMISSIONS.VALIDATE_PROGRAM,
    PERMISSIONS.VALIDATE_SPECIAL_PRICING_PROGRAM,
    PERMISSIONS.READ_PROCESSING_STAGES_TABLE,
    PERMISSIONS.DELETE_PROCESSING_STAGES,
    PERMISSIONS.READ_INQUIRIES_REMOVAL_STAGES,
    PERMISSIONS.READ_READY_TO_SETTLE_STAGES_TABLE,
    PERMISSIONS.COMPLETE_READY_TO_SETTLE_STAGES,
    PERMISSIONS.READ_FIRST_PAYMENT_STAGES,
    PERMISSIONS.COMPLETE_FIRST_PAYMENT_STAGES,
    PERMISSIONS.READ_PAUSE_XP_STAGES_TABLE,
    PERMISSIONS.COMPLETE_PAUSE_XP_STAGES,
    PERMISSIONS.READ_PAID_IN_FULL_DASHBOARD,
];

/**
 * Permissions for Conversation section
 */
export const CONVERSATION_PERMISSIONS = [
    {
        text: "Read Conversations: ",
        dropdown_options: [
            {
                label: "All",
                value: PERMISSIONS.READ_CONVERSATION,
                markAll: true,
            },
            {
                label: "Own",
                value: PERMISSIONS.READ_CONVERSATION_OWN,
            },
        ],
    },
    PERMISSIONS.UPDATE_CONVERSATION_RESPONSIBLE,
    PERMISSIONS.UPDATE_CONVERSATION_WATCHERS,
];

/**
 * Permissions for LEADS pages
 */
export const LEAD_PERMISSIONS = {
    access: PERMISSIONS.LEAD_ACCESS,
    sections: [
        {
            title: "General",
            permissions: [
                {
                    text: "Access to: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_READ,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_READ_OWN,
                        },
                    ],
                },
                PERMISSIONS.LEAD_CREATE,
                // PERMISSIONS.LEAD_UPDATE,
                PERMISSIONS.LEAD_DELETE,
                PERMISSIONS.LEAD_IMPORT,
                PERMISSIONS.LEAD_UPDATE_FLAG,
                PERMISSIONS.LEAD_UPDATE_UNFLAG,
                PERMISSIONS.LEAD_UPDATE_CHECKMARK,
                PERMISSIONS.LEAD_UPDATE_UNCHECKMARK,
                {
                    text: "Update Customer Service Rep: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_CUSTOMER_SERVICE_REP,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_CUSTOMER_SERVICE_REP_OWN,
                        },
                    ],
                },
                {
                    text: "Update Telemarketer: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_TELEMARKETER,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_TELEMARKETER_OWN,
                        },
                    ],
                },
                {
                    text: "Update Agent: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Real Estate Agent: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_RE_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_RE_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Funding Agent: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_FUNDING_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_FUNDING_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Loan Officer: ",
                    dropdown_options: [
                        {
                            label: "All Leads",
                            value: PERMISSIONS.LEAD_UPDATE_LOAN_OFFICER,
                            markAll: true,
                        },
                        {
                            label: "Own Leads",
                            value: PERMISSIONS.LEAD_UPDATE_LOAN_OFFICER_OWN,
                        },
                    ],
                },
                PERMISSIONS.LEAD_DETAILS,
                PERMISSIONS.LEAD_UPDATE_CONVERT,
            ],
        },
        {
            title: "Overall",
            permissions: [
                PERMISSIONS.LEAD_READ_OVERALL,
                PERMISSIONS.LEAD_UPDATE_OVERALL,
                PERMISSIONS.LEAD_READ_ADS,
                PERMISSIONS.LEAD_UPDATE_ADS,
                PERMISSIONS.LEAD_CREATE_CREDIT_SCORES,
                PERMISSIONS.LEAD_UPDATE_CREDIT_SCORES,
                PERMISSIONS.LEAD_DELETE_CREDIT_SCORES,
            ],
        },
        {
            title: "Programs",
            permissions: [
                PERMISSIONS.LEAD_READ_PROGRAM,
                PERMISSIONS.LEAD_CREATE_PROGRAM,
                PERMISSIONS.LEAD_READ_QUOTES,
                PERMISSIONS.LEAD_CREATE_QUOTES,
                PERMISSIONS.LEAD_UPDATE_QUOTES,
                PERMISSIONS.LEAD_DELETE_QUOTES,
                PERMISSIONS.LEAD_UPDATE_PAYMENT_METHODS,
                // PERMISSIONS.LEAD_UPDATE_PROGRAM_CONTRACT_CLOSED,
                // PERMISSIONS.LEAD_UPDATE_PROGRAM_STATUS,
                // PERMISSIONS.LEAD_READ_PROGRAM_AGENT_FEE,
                // PERMISSIONS.LEAD_READ_PROGRAM_PRICE,
                // PERMISSIONS.LEAD_READ_PROGRAM_INFO,
                // PERMISSIONS.LEAD_DELETE_PROGRAM,
            ],
        },
        {
            title: "Financial Disclosure",
            permissions: [
                PERMISSIONS.LEAD_READ_FINANCIAL,
                PERMISSIONS.LEAD_UPDATE_FINANCIAL,
            ],
        },
        {
            title: "Documents",
            permissions: [
                PERMISSIONS.LEAD_READ_DOCUMENT,
                PERMISSIONS.LEAD_IMPORT_DOCUMENT,
                PERMISSIONS.LEAD_DELETE_DOCUMENT,
            ],
        },
        {
            title: "Notes",
            permissions: [
                PERMISSIONS.LEAD_READ_NOTES,
                PERMISSIONS.LEAD_CREATE_NOTES,
                PERMISSIONS.LEAD_UPDATE_NOTES,
                PERMISSIONS.LEAD_DELETE_NOTES,
            ],
        },
        {
            title: "Conversations",
            permissions: [PERMISSIONS.LEAD_READ_CONVERSATION, PERMISSIONS.LEAD_CREATE_CONVERSATION],
        },
        {
            title: "Activity",
            permissions: [PERMISSIONS.LEAD_ACTIVITY_TAB],
        },
    ],
};

/**
 * Permissions for CLIENTS pages
 */
export const CLIENT_PERMISSIONS = {
    access: PERMISSIONS.CLIENT_ACCESS,
    sections: [
        {
            title: "General",
            permissions: [
                {
                    text: "Access to: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_READ,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_READ_OWN,
                        },
                        {
                            label: "Bankruptcy Clients",
                            value: PERMISSIONS.CLIENT_READ_BANKRUPTCY,
                        },
                    ],
                },
                PERMISSIONS.CLIENT_CREATE,
                // PERMISSIONS.CLIENT_UPDATE,
                PERMISSIONS.CLIENT_DELETE,
                PERMISSIONS.CLIENT_IMPORT,
                {
                    text: "Update Customer Service Rep: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_CUSTOMER_SERVICE_REP,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_CUSTOMER_SERVICE_REP_OWN,
                        },
                    ],
                },
                {
                    text: "Update Telemarketer: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_TELEMARKETER,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_TELEMARKETER_OWN,
                        },
                    ],
                },
                {
                    text: "Update Agent: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Real Estate Agent: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_RE_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_RE_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Funding Agent: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_FUNDING_AGENT,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_FUNDING_AGENT_OWN,
                        },
                    ],
                },
                {
                    text: "Update Loan Officer: ",
                    dropdown_options: [
                        {
                            label: "All Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_LOAN_OFFICER,
                            markAll: true,
                        },
                        {
                            label: "Own Clients",
                            value: PERMISSIONS.CLIENT_UPDATE_LOAN_OFFICER_OWN,
                        },
                    ],
                },
                PERMISSIONS.CLIENT_UPDATE_FLAG,
                PERMISSIONS.CLIENT_UPDATE_UNFLAG,
                PERMISSIONS.CLIENT_UPDATE_CHECKMARK,
                PERMISSIONS.CLIENT_UPDATE_UNCHECKMARK,
                PERMISSIONS.CLIENT_ACTIVITY,
                PERMISSIONS.CLIENT_DETAILS,
                PERMISSIONS.CLIENT_PRODUCTION,
            ],
        },
        {
            title: "Overall",
            permissions: [
                PERMISSIONS.CLIENT_READ_OVERALL,
                PERMISSIONS.CLIENT_UPDATE_OVERALL,
                PERMISSIONS.CLIENT_READ_ADS,
                PERMISSIONS.CLIENT_UPDATE_ADS,
                PERMISSIONS.CLIENT_CREATE_CREDIT_SCORES,
                PERMISSIONS.CLIENT_UPDATE_CREDIT_SCORES,
                PERMISSIONS.CLIENT_DELETE_CREDIT_SCORES,
            ],
        },
        {
            title: "Programs",
            permissions: [
                PERMISSIONS.CLIENT_READ_PROGRAM,
                PERMISSIONS.CLIENT_CREATE_PROGRAM,
                PERMISSIONS.CLIENT_UPDATE_PROGRAM_CONTRACT_CLOSED,
                PERMISSIONS.CLIENT_UPDATE_PROGRAM_STATUS,
                PERMISSIONS.CLIENT_UPDATE_PROGRAM_INFO,
                PERMISSIONS.CLIENT_READ_PROGRAM_AGENT_FEE,
                PERMISSIONS.CLIENT_READ_PROGRAM_PRICE,
                PERMISSIONS.CLIENT_READ_PROGRAM_INFO,
                PERMISSIONS.CLIENT_DELETE_PROGRAM,
                PERMISSIONS.CLIENT_READ_QUOTES,
                PERMISSIONS.CLIENT_CREATE_QUOTES,
                PERMISSIONS.CLIENT_UPDATE_QUOTES,
                PERMISSIONS.CLIENT_DELETE_QUOTES,
            ],
        },
        {
            title: "Bankruptcy",
            permissions: [
                PERMISSIONS.CLIENT_READ_BANKRUPTCY_TAB,
                PERMISSIONS.CLIENT_UPDATE_BANKRUPTCY_TAB,
            ],
        },
        {
            title: "Payment",
            permissions: [
                PERMISSIONS.CLIENT_READ_PAYMENT,
                PERMISSIONS.CLIENT_UNLOCK_PAYMENT_METHODS,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_METHODS,
                PERMISSIONS.CLIENT_READ_PAYMENT_TRANSACTIONS,
                PERMISSIONS.CLIENT_CREATE_PAYMENT_TRANSACTIONS,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_TRANSACTIONS,
                PERMISSIONS.CLIENT_READ_PAYMENT_RE_TRANSACTIONS,
                PERMISSIONS.CLIENT_CREATE_PAYMENT_RE_TRANSACTIONS,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_RE_TRANSACTIONS,
                PERMISSIONS.CLIENT_DELETE_PAYMENT_RE_TRANSACTIONS,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_INFO,
                PERMISSIONS.CLIENT_READ_PAYMENT_FEES,
                PERMISSIONS.CLIENT_CREATE_PAYMENT_FEES,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_FEES,
                PERMISSIONS.CLIENT_DELETE_PAYMENT_FEES,
                PERMISSIONS.CLIENT_READ_PAYMENT_FEES_TRANSACTIONS,
                PERMISSIONS.CLIENT_CREATE_PAYMENT_FEES_TRANSACTIONS,
                PERMISSIONS.CLIENT_UPDATE_PAYMENT_FEES_TRANSACTIONS,
            ],
        },
        {
            title: "Commissions",
            permissions: [
                PERMISSIONS.CLIENT_READ_CLIENT_COMMISSIONS,
                PERMISSIONS.CLIENT_UPDATE_CLIENT_COMMISSIONS,
            ],
        },
        {
            title: "Financial Disclosure",
            permissions: [
                PERMISSIONS.CLIENT_READ_FINANCIAL,
                PERMISSIONS.CLIENT_UPDATE_FINANCIAL,
            ],
        },
        {
            title: "Real Estate",
            permissions: [
                PERMISSIONS.CLIENT_READ_REAL_ESTATE,
                PERMISSIONS.CLIENT_UPDATE_REAL_ESTATE,
                PERMISSIONS.CLIENT_READ_RE_COMMISSIONS,
                PERMISSIONS.CLIENT_UPDATE_RE_COMMISSIONS,
                PERMISSIONS.CLIENT_READ_RE_D_COMMISSIONS,
                PERMISSIONS.CLIENT_UPDATE_RE_D_COMMISSIONS,
            ],
        },
        {
            title: "Processing",
            permissions: [
                PERMISSIONS.CLIENT_READ_PROCESSING,
                PERMISSIONS.CLIENT_UPDATE_PROCESSING,
                PERMISSIONS.CLIENT_READ_PROCESSING_PROCESS,
                PERMISSIONS.CLIENT_CREATE_PROCESSING_PROCESS,
                PERMISSIONS.CLIENT_DELETE_PROCESSING_PROCESS,
                PERMISSIONS.CLIENT_UPDATE_PROCESSING_PROCESS,
                PERMISSIONS.CLIENT_READ_PROCESSING_PLATFORM_ACCESS,
                PERMISSIONS.CLIENT_CREATE_PROCESSING_PLATFORM_ACCESS,
                PERMISSIONS.CLIENT_DELETE_PROCESSING_PLATFORM_ACCESS,
                PERMISSIONS.CLIENT_UPDATE_PROCESSING_PLATFORM_ACCESS,
            ],
        },
        {
            title: "Funding",
            permissions: [
                PERMISSIONS.CLIENT_READ_FUNDING,
                PERMISSIONS.CLIENT_READ_FUNDING_CREDIT_LINES,
                PERMISSIONS.CLIENT_CREATE_FUNDING_CREDIT_LINES,
                PERMISSIONS.CLIENT_UPDATE_FUNDING_CREDIT_LINES,
                PERMISSIONS.CLIENT_DELETE_FUNDING_CREDIT_LINES,
                PERMISSIONS.CLIENT_READ_FUNDING_BANK_ACCESS,
                PERMISSIONS.CLIENT_CREATE_FUNDING_BANK_ACCESS,
                PERMISSIONS.CLIENT_UPDATE_FUNDING_BANK_ACCESS,
                PERMISSIONS.CLIENT_DELETE_FUNDING_BANK_ACCESS,
            ],
        },
        {
            title: "Tradelines",
            permissions: [
                PERMISSIONS.CLIENT_READ_TRADELINES,
                PERMISSIONS.CLIENT_UPDATE_TRADELINES,
                PERMISSIONS.CLIENT_READ_TRADELINES_TRADELINE,
                PERMISSIONS.CLIENT_CREATE_TRADELINES_TRADELINE,
                PERMISSIONS.CLIENT_DELETE_TRADELINES_TRADELINE,
                PERMISSIONS.CLIENT_UPDATE_TRADELINES_TRADELINE,
            ],
        },
        {
            title: "Settlements",
            permissions: [
                PERMISSIONS.CLIENT_READ_SETTLEMENTS,
                PERMISSIONS.CLIENT_READ_SETTLEMENTS_SETTLEMENT,
                PERMISSIONS.CLIENT_CREATE_SETTLEMENTS_SETTLEMENT,
                PERMISSIONS.CLIENT_DELETE_SETTLEMENTS_SETTLEMENT,
                PERMISSIONS.CLIENT_UPDATE_SETTLEMENTS_SETTLEMENT,
                PERMISSIONS.CLIENT_CREATE_SETTLEMENTS_NOTIFICATION,
                PERMISSIONS.CLIENT_READ_SETTLEMENTS_CREDIT_CARD,
                PERMISSIONS.CLIENT_CREATE_SETTLEMENTS_CREDIT_CARD,
                PERMISSIONS.CLIENT_DELETE_SETTLEMENTS_CREDIT_CARD,
                PERMISSIONS.CLIENT_UPDATE_SETTLEMENTS_CREDIT_CARD,
            ],
        },
        {
            title: "Accounts",
            permissions: [
                PERMISSIONS.CLIENT_READ_ACCOUNTS,
                PERMISSIONS.CLIENT_CREATE_ACCOUNTS,
                PERMISSIONS.CLIENT_DELETE_ACCOUNTS,
                PERMISSIONS.CLIENT_UPDATE_ACCOUNTS,
            ],
        },
        {
            title: "Violations",
            permissions: [
                PERMISSIONS.CLIENT_READ_VIOLATIONS,
                PERMISSIONS.CLIENT_CREATE_VIOLATIONS,
                PERMISSIONS.CLIENT_DELETE_VIOLATIONS,
                PERMISSIONS.CLIENT_UPDATE_VIOLATIONS,
            ],
        },
        {
            title: "Documents",
            permissions: [
                PERMISSIONS.CLIENT_READ_DOCUMENT,
                PERMISSIONS.CLIENT_IMPORT_DOCUMENT,
                PERMISSIONS.CLIENT_DELETE_DOCUMENT,
            ],
        },
        {
            title: "Notes",
            permissions: [
                PERMISSIONS.CLIENT_READ_NOTES,
                PERMISSIONS.CLIENT_CREATE_NOTES,
                PERMISSIONS.CLIENT_DELETE_NOTES,
                PERMISSIONS.CLIENT_UPDATE_NOTES,
            ],
        },
        {
            title: "Conversations",
            permissions: [
                PERMISSIONS.CLIENT_READ_CONVERSATION,
                PERMISSIONS.CLIENT_CREATE_CONVERSATION,
            ],
        },
        {
            title: "Activity",
            permissions: [PERMISSIONS.CLIENT_ACTIVITY_TAB],
        },
    ],
};

/**
 * Permissions for OPPORTUNITIES pages (per type)
 */
export const OPPORTUNITIES_PERMISSIONS = {
    access: PERMISSIONS.OPPORTUNITY_ACCESS_TAB,
    sections: [
        {
            title: "Credit Repair",
            permissions: [
                PERMISSIONS.OPPORTUNITY_CREDIT_REPAIR_READ,
                PERMISSIONS.OPPORTUNITY_CREDIT_REPAIR_CREATE,
                PERMISSIONS.OPPORTUNITY_CREDIT_REPAIR_UPDATE,
                PERMISSIONS.OPPORTUNITY_CREDIT_REPAIR_DELETE,
            ],
        },
        {
            title: "Buyer",
            permissions: [
                PERMISSIONS.OPPORTUNITY_BUYER_READ,
                PERMISSIONS.OPPORTUNITY_BUYER_CREATE,
                PERMISSIONS.OPPORTUNITY_BUYER_UPDATE,
                PERMISSIONS.OPPORTUNITY_BUYER_DELETE,
            ],
        },
        {
            title: "HELOC",
            permissions: [
                PERMISSIONS.OPPORTUNITY_HELOC_READ,
                PERMISSIONS.OPPORTUNITY_HELOC_CREATE,
                PERMISSIONS.OPPORTUNITY_HELOC_UPDATE,
                PERMISSIONS.OPPORTUNITY_HELOC_DELETE,
            ],
        },
        {
            title: "Mortgage",
            permissions: [
                PERMISSIONS.OPPORTUNITY_MORTGAGE_READ,
                PERMISSIONS.OPPORTUNITY_MORTGAGE_CREATE,
                PERMISSIONS.OPPORTUNITY_MORTGAGE_UPDATE,
                PERMISSIONS.OPPORTUNITY_MORTGAGE_DELETE,
            ],
        },
        {
            title: "Refinancing",
            permissions: [
                PERMISSIONS.OPPORTUNITY_REFINANCING_READ,
                PERMISSIONS.OPPORTUNITY_REFINANCING_CREATE,
                PERMISSIONS.OPPORTUNITY_REFINANCING_UPDATE,
                PERMISSIONS.OPPORTUNITY_REFINANCING_DELETE,
            ],
        },
        {
            title: "Seller",
            permissions: [
                PERMISSIONS.OPPORTUNITY_SELLER_READ,
                PERMISSIONS.OPPORTUNITY_SELLER_CREATE,
                PERMISSIONS.OPPORTUNITY_SELLER_UPDATE,
                PERMISSIONS.OPPORTUNITY_SELLER_DELETE,
            ],
        },
    ],
};

/**
 * Permissions for EMPLOYEES pages
 */
export const EMPLOYEE_PERMISSIONS = [
    {
        text: "Access to: ",
        dropdown_options: [
            {
                label: "All Employees",
                value: PERMISSIONS.EMPLOYEE_READ,
                markAll: true,
            },
            {
                label: "All but own",
                value: PERMISSIONS.EMPLOYEE_READ_NOT_OWN,
            },
        ],
    },
    PERMISSIONS.EMPLOYEE_CREATE,
    PERMISSIONS.EMPLOYEE_DELETE,
    PERMISSIONS.EMPLOYEE_READ_OVERALL,
    PERMISSIONS.EMPLOYEE_UPDATE_OVERALL,
    PERMISSIONS.EMPLOYEE_READ_CONTACT,
    PERMISSIONS.EMPLOYEE_CREATE_NOTES,
    PERMISSIONS.EMPLOYEE_UPDATE_NOTES,
    PERMISSIONS.EMPLOYEE_DELETE_NOTES,
    PERMISSIONS.EMPLOYEE_IMPORT_DOCUMENT,
    PERMISSIONS.EMPLOYEE_DELETE_DOCUMENT,
    PERMISSIONS.EMPLOYEE_READ_COMMISSIONS,
    PERMISSIONS.EMPLOYEE_UPDATE_COMMISSIONS,
];

/**
 * Permissions for CAMPAIGNS pages
 */
export const CAMPAIGNS_PERMISSIONS = [
    PERMISSIONS.CAMPAIGN_READ_BULK_MESSAGES,
    PERMISSIONS.CAMPAIGN_CREATE_BULK_MESSAGES,
    PERMISSIONS.CAMPAIGN_READ,
    PERMISSIONS.CAMPAIGN_CREATE,
    PERMISSIONS.CAMPAIGN_DELETE,
    PERMISSIONS.CAMPAIGN_UPDATE,
];

/**
 * Permissions for USERS pages
 */
export const USERS_PERMISSIONS = [
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_CREATE,
    PERMISSIONS.USER_UPDATE,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.USER_REASSIGN,
    PERMISSIONS.USER_UPDATE_ROLE_PERMISSIONS,
    PERMISSIONS.USER_UPDATE_PASSWORD,
];

/**
 * Permissions for CALENDAR pages
 */
export const CALENDAR_PERMISSIONS = [
    {
        text: "View: ",
        dropdown_options: [
            {
                label: "All Appointments",
                value: PERMISSIONS.CALENDAR_READ_APPOINTMENTS,
                markAll: true,
            },
            {
                label: "Own Appointments",
                value: PERMISSIONS.CALENDAR_READ_APPOINTMENTS_OWN,
            },
        ],
    },
    PERMISSIONS.CALENDAR_CREATE_APPOINTMENTS,
    PERMISSIONS.CALENDAR_UPDATE_APPOINTMENTS,
    PERMISSIONS.CALENDAR_DELETE_APPOINTMENTS,
    PERMISSIONS.CALENDAR_CREATE_APPOINTMENTS_SUPERIOR,
    PERMISSIONS.CALENDAR_CREATE_APPOINTMENTS_INFERIOR,
    PERMISSIONS.CALENDAR_READ_APPOINTMENTS_ASSIGNED_BY,
    {
        text: "View: ",
        dropdown_options: [
            {
                label: "All Tasks",
                value: PERMISSIONS.CALENDAR_READ_TASKS,
                markAll: true,
            },
            {
                label: "Own Tasks",
                value: PERMISSIONS.CALENDAR_READ_TASKS_OWN,
            },
        ],
    },
    PERMISSIONS.CALENDAR_CREATE_TASKS,
    PERMISSIONS.CALENDAR_UPDATE_TASKS,
    PERMISSIONS.CALENDAR_DELETE_TASKS,
    PERMISSIONS.CALENDAR_CREATE_TASKS_SUPERIOR,
    PERMISSIONS.CALENDAR_CREATE_TASKS_INFERIOR,
    PERMISSIONS.CALENDAR_READ_TASKS_ASSIGNED_BY,
];

/**
 * Permissions for SETTINGS Pages
 */
export const SETTINGS_PERMISSIONS = [
    PERMISSIONS.SETTINGS_READ_DROPDOWNS,
    PERMISSIONS.SETTINGS_READ_ROUND_ROBIN,
    PERMISSIONS.SETTINGS_READ_CREDITORS,
    PERMISSIONS.SETTINGS_READ_CR_PRICING,
    PERMISSIONS.SETTINGS_READ_ANUAL_INTEREST,
    PERMISSIONS.SETTINGS_UPDATE_DROPDOWNS,
    PERMISSIONS.SETTINGS_UPDATE_ROUND_ROBIN,
    PERMISSIONS.SETTINGS_UPDATE_CREDITORS,
    PERMISSIONS.SETTINGS_UPDATE_CR_PRICING,
    PERMISSIONS.SETTINGS_UPDATE_ANUAL_INTEREST,
    PERMISSIONS.SETTINGS_READ_LEGAL_TEXTS,
    PERMISSIONS.SETTINGS_UPDATE_LEGAL_TEXTS,
    PERMISSIONS.SETTINGS_READ_ROLES,
    PERMISSIONS.SETTINGS_UPDATE_ROLES,
    PERMISSIONS.REFERRAL_AGENT_READ,
    PERMISSIONS.REFERRAL_AGENT_CREATE,
    PERMISSIONS.REFERRAL_AGENT_UPDATE,
    PERMISSIONS.REFERRAL_AGENT_DELETE,
];

/**
 * Permissions for TUTORIALS pages
 */
export const TUTORIALS_PERMISSIONS = [
    PERMISSIONS.TUTORIAL_READ,
    PERMISSIONS.TUTORIAL_CREATE,
    PERMISSIONS.TUTORIAL_UPDATE,
    PERMISSIONS.TUTORIAL_DELETE,
];

/**
 * Permissions for ANALYTICS pages
 */
export const CHAT_PERMISSIONS = [
    PERMISSIONS.ANALYTICS_CREATE,
    PERMISSIONS.ANALYTICS_UPDATE,
    PERMISSIONS.ANALYTICS_DELETE,
    PERMISSIONS.ANALYTICS_READ,
]

export const REPORTS_PERMISSIONS = [
    PERMISSIONS.VIEW_CREDIT_SALES_ANALYTICS,
    PERMISSIONS.VIEW_TELEMARKETING_ANALYTICS,
    PERMISSIONS.VIEW_RE_COMMISSIONS_ANALYTICS,
    PERMISSIONS.VIEW_ADS_ANALYTICS,
];
export const ANALYTICS_PERMISSIONS = [
    ...CHAT_PERMISSIONS,
    ...REPORTS_PERMISSIONS,
];

export const PAYMENTS_PERMISSIONS = [
    PERMISSIONS.PAYMENTS_READ,
    // PERMISSIONS.PAYMENTS_CREATE,
    // PERMISSIONS.PAYMENTS_UPDATE,
    // PERMISSIONS.PAYMENTS_DELETE,
];

/**
 * Permissions for TEAMHUB pages
 */
export const TEAMHUB_PERMISSIONS = {
    access: PERMISSIONS.TEAMHUB_ACCESS,
    sections: [
        {
            title: "Templates",
            permissions: [
                PERMISSIONS.TEAMHUB_TEMPLATES_ACCESS,
                PERMISSIONS.TEAMHUB_VIEW_ALL_TEMPLATES,
                PERMISSIONS.TEAMHUB_CREATE_FOLDERS,
                PERMISSIONS.TEAMHUB_EDIT_FOLDERS,
                PERMISSIONS.TEAMHUB_DELETE_FOLDERS,
                PERMISSIONS.TEAMHUB_CREATE_SYSTEM_TEMPLATES,
                PERMISSIONS.TEAMHUB_EDIT_SYSTEM_TEMPLATES,
                PERMISSIONS.TEAMHUB_DELETE_SYSTEM_TEMPLATES,
                PERMISSIONS.TEAMHUB_CREATE_OWN_TEMPLATES,
                PERMISSIONS.TEAMHUB_EDIT_OWN_TEMPLATES,
                PERMISSIONS.TEAMHUB_DELETE_OWN_TEMPLATES,
                PERMISSIONS.TEAMHUB_CREATE_TEAM_TEMPLATES,
                PERMISSIONS.TEAMHUB_EDIT_TEAM_TEMPLATES,
                PERMISSIONS.TEAMHUB_DELETE_TEAM_TEMPLATES,
            ],
        },
        {
            title: "Schedules & Holidays",
            permissions: [
                PERMISSIONS.TEAMHUB_SCHEDULE_ACCESS,
                PERMISSIONS.TEAMHUB_CALENDAR_READ,
                PERMISSIONS.TEAMHUB_CALENDAR_CREATE,
                PERMISSIONS.TEAMHUB_CALENDAR_UPDATE,
                PERMISSIONS.TEAMHUB_CALENDAR_DELETE,
                PERMISSIONS.TEAMHUB_SCHEDULES_READ,
                PERMISSIONS.TEAMHUB_SCHEDULES_CREATE,
                PERMISSIONS.TEAMHUB_SCHEDULES_UPDATE,
                PERMISSIONS.TEAMHUB_SCHEDULES_DELETE,
                PERMISSIONS.TEAMHUB_VACATIONS_READ,
                PERMISSIONS.TEAMHUB_VACATIONS_CREATE,
                PERMISSIONS.TEAMHUB_VACATIONS_UPDATE,
                PERMISSIONS.TEAMHUB_VACATIONS_DELETE,
                PERMISSIONS.TEAMHUB_HOLIDAYS_READ,
                PERMISSIONS.TEAMHUB_HOLIDAYS_CREATE,
                PERMISSIONS.TEAMHUB_HOLIDAYS_UPDATE,
                PERMISSIONS.TEAMHUB_HOLIDAYS_DELETE,
                PERMISSIONS.TEAMHUB_LIVE_ATTENDANCE_ACCESS,
                PERMISSIONS.TEAMHUB_TIMECARD_REPORT_ACCESS,
            ],
        },
        {
            title: "Tools",
            permissions: [
                PERMISSIONS.TEAMHUB_TOOLS_ACCESS,
                PERMISSIONS.TEAMHUB_TOOLS_RDC_CREDIT_COST_CLOSER,
            ],
        },
        {
            title: "Tickets",
            permissions: [PERMISSIONS.TEAMHUB_TICKETS_ACCESS, PERMISSIONS.TEAMHUB_TICKETS_MANAGE],
        },
    ],
};

/**
 * Permissions for BUSINESSES pages
 */
export const BUSINESSES_PERMISSIONS = {
    access: PERMISSIONS.BUSINESS_ACCESS_TAB,
    sections: [
        {
            title: "General",
            permissions: [
                PERMISSIONS.BUSINESS_READ,
                PERMISSIONS.BUSINESS_CREATE,
                PERMISSIONS.BUSINESS_UPDATE,
                PERMISSIONS.BUSINESS_DELETE,
                PERMISSIONS.BUSINESS_UNLOCK_BANK_INFORMATION,
            ],
        },
        {
            title: "Documents",
            permissions: [
                PERMISSIONS.BUSINESS_READ_DOCUMENT,
                PERMISSIONS.BUSINESS_CREATE_DOCUMENT,
                PERMISSIONS.BUSINESS_DELETE_DOCUMENT,
            ],
        },
        {
            title: "Notes",
            permissions: [
                PERMISSIONS.BUSINESS_READ_NOTES,
                PERMISSIONS.BUSINESS_CREATE_NOTES,
                PERMISSIONS.BUSINESS_UPDATE_NOTES,
                PERMISSIONS.BUSINESS_DELETE_NOTES,
            ],
        },
        {
            title: "VOE",
            permissions: [PERMISSIONS.BUSINESS_READ_VOE],
        }
    ],
};
/**
 * Mapper from permission name in auth0 to text to show on user's page
 */
export const PERMISSION_TITLE_MAPPER: any = {
    "validate:program": "Validate Programs",
    "validate:special_pricing_program": "Validate Special Pricing Programs",
    "read:processing_stages": "Read Processing Stages Table",
    "delete:processing_stage": "Delete and Stop Procesing Stage",
    "read:inquiries_removal_stages": "Read Inquiries Removal Stages",
    "read:first_payment_stages": "Read First Payment Stages Table",
    "complete:first_payment_stage": "Complete First Payment Stage",
    "read:paid_in_full_dashboard": "Read Paid In Full Dashboard",
    "read:ready_to_settle_stages": "Read Settlements Table",
    "complete:ready_to_settle_stage": "Complete Settlements Table",
    "update:conversation_watchers": "Update Conversation Watchers",
    "read:lead / read:lead_own": "View All Leads // View Own Leads (Based on Role)",
    "create:lead": "Create New Leads",
    "delete:lead": "Delete Leads",
    "create:lead_import": "Import Leads",
    "update:lead_flag": "Red Flag Leads on Leads",
    "update:lead_unflag": "Remove flagged status on Leads",
    "update:lead_checkmark": "Checkmark Leads",
    "update:lead_uncheckmark": "Remove checkmarked status on Leads",
    "update:lead_agent": "Edit Lead's Agent Assigned",
    "update:lead_re_agent": "Update Lead's Real Estate Agent",
    "update:lead_funding_agent": "Update Lead's Funding Agent",
    "update:lead_loan_officer": "Update Lead's Loan Officer",
    "read:lead_details": 'View "View Details" Leads Table',
    "update:lead_convert": "Convert Lead to a Client",
    "read:lead_overall": "View Overall's Lead Tab",
    "update:lead_overall": "Edit Overall's Lead Tab Information",
    "read:lead_ads": "View Ads Section in Lead's Overall Tab",
    "update:lead_ads": "Edit Ads Section in Lead's Overall Tab",
    "create:lead_credit_scores": "Create New Credit Score in Lead",
    "update:lead_credit_scores": "Edit Credit Scores in Lead",
    "delete:lead_credit_scores": "Delete Credit Scores in Lead",
    "read:lead_program": "View Programs' Lead Tab",
    "create:lead_program": "Create Lead's Program ",
    "update:lead_program_contract_closed": "Edit Contract Closed in Leads Programs",
    "update:lead_program_status": "Edit Status in Leads Programs",
    "read:lead_program_agent_fee": "View Agent Fee in Leads Programs",
    "read:lead_program_price": "View Price in Leads Programs",
    "read:lead_program_info": "View Program Info in Leads Programs",
    "delete:lead_program": "Delete Leads Programs ",
    "read:lead_quotes": "View Leads' Quotes",
    "create:lead_quotes": "Create Leads' Quotes",
    "update:lead_quotes": "Edit Leads' Quotes",
    "delete:lead_quotes": "Delete Leads' Quotes",
    "update:lead_payment_methods": "Manage Payment Methods in Leads",
    "read:lead_financial": "View Financial Disclousure's Lead Tab",
    "update:lead_financial": "Edit Financial Disclousure's Lead Tab",
    "read:lead_document": "View Documents' Lead Tab",
    "import:lead_document": "Upload Documents in Leads",
    "delete:lead_document": "Delete Documents in Leads",
    "read:lead_notes": "View Notes' Lead Tab",
    "create:lead_notes": "Create Notes in Leads",
    "update:lead_notes": "Edit Notes in Leads",
    "delete:lead_notes": "Delete Notes on Leads",
    "read:lead_conversation": "View Messages in Leads",
    "create:lead_conversation": "Send Messages in Leads",
    "read:lead_activity_tab": "Acces Leads's Activity Tab",
    "create:client": "Create New Clients",
    "delete:client": "Delete Clients",
    "create:client_import": "Import Clients",
    "update:client_flag": "Red Flag Clients",
    "update:client_unflag": "Remove flagged status in Clients",
    "update:client_checkmark": "Checkmark Clients",
    "update:client_uncheckmark": "Remove checkmarked status on Clients",
    "update:client_agent": "Edit Agent's Client",
    "update:client_re_agent": "Update Client's Real Estate Agent",
    "update:client_funding_agent": "Update Client's Funding Agent",
    "update:client_loan_officer": "Update Client's Loan Officer",
    "read:client_activity": 'View "Acitivity Supervision" Client Table',
    "read:client_details": 'View "Client Details" Client Table',
    "read:client_production": 'View "Production Audit" Client Table',
    "read:client_overall": "View Overall's Client Tab",
    "update:client_overall": "Edit Overall's Client Tab",
    "read:client_ads": "View Ads Section in Client's Overall Tab",
    "update:client_ads": "Edit Ads Section in Client's Overall Tab",
    "create:client_credit_scores": "Create New Credit Score in Client",
    "update:client_credit_scores": "Edit Credit Scores in Client",
    "delete:client_credit_scores": "Delete Credit Scores in Client",
    "read:client_program": "View Programs' Client Tab",
    "create:client_program": "Create Programs in Clients Tab",
    "update:client_program_contract_closed": "Edit Contract Closed in Clients Programs",
    "update:client_program_status": "Edit Status in Clients Programs",
    "read:client_program_agent_fee": "View Agent Fee in Clients Programs",
    "read:client_program_price": "View Price in Clients Programs",
    "read:client_program_info": "View Program Info in Clients Programs",
    "update:client_program_info": "Edit Program Info in Clients Programs",
    "read:client_quotes": "View Clients' Quotes",
    "create:client_quotes": "Create Clients' Quotes",
    "update:client_quotes": "Edit Clients' Quotes",
    "delete:client_quotes": "Delete Clients' Quotes",
    "delete:client_program": "Delete Clients' Programs ",
    "read:client_bankruptcy_tab": "View Bankruptcy's Client Tab",
    "update:client_bankruptcy_tab": "Edit Bankruptcy's Client Tab",
    "read:client_payment": "View Payment's Client Tab",
    "read:client_commissions": "View Commissions in Clients",
    "update:client_commissions": "Manage Commissions in Clients",
    "unlock:client_payment_methods": "View Payment Methods on Payment's Tab",
    "update:client_payment_methods": "Manage Payment Methods on Payment's Tab",
    "read:client_payment_transactions": "View Client Transactions",
    "create:client_payment_transactions": "Create Client Transactions",
    "update:client_payment_transactions": "Edit Client Transactions",
    "read:client_payment_re_transactions": "View Client Real Estate Transactions",
    "create:client_payment_re_transactions": "Create Client Real Estate Transactions",
    "update:client_payment_re_transactions": "Edit Client Real Estate Transactions",
    "delete:client_payment_re_transactions": "Delete Client Real Estate Transactions",
    "update:client_payment_info": "Edit Client Payment Information",
    "read:client_payment_fees": "View Client Fees",
    "create:client_payment_fees": "Create Client Fees",
    "update:client_payment_fees": "Edit Client Fees",
    "delete:client_payment_fees": "Delete Client Fees",
    "read:client_payment_fees_transactions": "View Client Fees Transactions",
    "create:client_payment_fees_transactions": "Create Client Fees Transactions",
    "update:client_payment_fees_transactions": "Edit Client Fees Transactions",
    "read:client_financial": "View Financial Disclousure's Client Tab",
    "update:client_financial": "Edit Financial Disclousure's Client Tab",
    "read:client_real_estate": "View Real Estate's Client Tab",
    "update:client_real_estate": "Edit Real Estate's Client Tab",
    "read:client_re_commissions": "View Real Estate Commissions",
    "update:client_re_commissions": "Edit Real Estate Commissions",
    "read:client_re_d_commissions": "View D. A. / D. P. in Real Estate",
    "update:client_re_d_commissions": "Edit D. A. / D. P. in Real Estate",
    "read:client_processing": "View Processing's Client Tab",
    "update:client_processing": "Edit Processing's Client Tab",
    "read:client_processing_process": "View Client Processes",
    "create:client_processing_process": "Create Client Processes",
    "delete:client_processing_process": "Delete Client Processes",
    "update:client_processing_process": "Edit Client Processes",
    "read:client_processing_platform_access": "View Client Platforms Access",
    "create:client_processing_platform_access": "Create Client Platforms Access",
    "delete:client_processing_platform_access": "Delete Client Platforms Access",
    "update:client_processing_platform_access": "Update Client Platforms Access",
    "read:client_funding": "View Funding's Client Tab",
    "read:client_funding_credit_lines": "View Client Credit Lines",
    "create:client_funding_credit_lines": "Create Client Credit Lines",
    "update:client_funding_credit_lines": "Edit Client Credit Lines",
    "delete:client_funding_credit_lines": "Delete Client Credit Lines",
    "read:client_funding_bank_access": "View Client Bank Accesses",
    "create:client_funding_bank_access": "Create Client Bank Accesses",
    "delete:client_funding_bank_access": "Delete Client Bank Accesses",
    "update:client_funding_bank_access": "Edit Client Bank Accesses",
    "read:client_tradelines": "View Tradelines' Client Trab",
    "update:client_tradelines": "Edit Tradelines' Client Tab",
    "read:client_tradelines_tradeline": "View Client Tradelines",
    "create:client_tradelines_tradeline": "Create Client Tradelines",
    "delete:client_tradelines_tradeline": "Delete Client Tradelines",
    "update:client_tradelines_tradeline": "Edit Client Tradelines",
    "read:client_settlements": "View Settlements' Client Tab",
    "read:client_settlements_settlement": "View Client Settlements",
    "create:client_settlements_settlement": "Create Client Settlements",
    "delete:client_settlements_settlement": "Delete Client Settlements",
    "update:client_settlements_settlement": "Edit Client Settlements",
    "create:client_settlements_notification": "Notify Client Settlement",
    "read:client_settlements_credit_card": "View Client Credit Cards",
    "create:client_settlements_credit_card": "Create Client Credit Cards",
    "delete:client_settlements_credit_card": "Delete Client Credit Cards",
    "update:client_settlements_credit_card": "Edit Client Credit Cards",
    "read:client_accounts": "View Accounts' Client Tab",
    "create:client_accounts": "Create Client Accounts",
    "delete:client_accounts": "Delete Client Accounts",
    "update:client_accounts": "Edit Client Accounts",
    "read:client_violations": "View Violations' Client Tab",
    "create:client_violations": "Create Client Violations",
    "delete:client_violations": "Delete Client Violations",
    "update:client_violations": "Edit Client Violations",
    "read:client_document": "View Documents' Client Tab",
    "import:client_document": "Upload Documents in Clients",
    "delete:client_document": "Delete Documents in Clients",
    "read:client_notes": "View Notes' Client Tab",
    "create:client_notes": "Create Notes in Clients",
    "update:client_notes": "Edit Notes in Clients",
    "delete:client_notes": "Delete Notes on Clients",
    "read:client_conversation": "View Messages in Clients",
    "create:client_conversation": "Send Messages in Clients",
    "read:client_activity_tab": "Access Client's Activity Tab",
    "read:conversation": "Read Conversations",
    "update:conversation_responsible": "Update Conversation Responsible",
    "read:opportunity_credit_repair": "Read Credit Repair Opportunities",
    "create:opportunity_credit_repair": "Create Credit Repair Opportunities",
    "update:opportunity_credit_repair": "Update Credit Repair Opportunities",
    "delete:opportunity_credit_repair": "Delete Credit Repair Opportunities",
    "read:opportunity_buyer": "Read Buyer Opportunities",
    "create:opportunity_buyer": "Create Buyer Opportunities",
    "update:opportunity_buyer": "Update Buyer Opportunities",
    "delete:opportunity_buyer": "Delete Buyer Opportunities",
    "read:opportunity_mortgage": "Read Mortgage Opportunities",
    "create:opportunity_mortgage": "Create Mortgage Opportunities",
    "update:opportunity_mortgage": "Update Mortgage Opportunities",
    "delete:opportunity_mortgage": "Delete Mortgage Opportunities",
    "read:opportunity_heloc": "Read HELOC Opportunities",
    "create:opportunity_heloc": "Create HELOC Opportunities",
    "update:opportunity_heloc": "Update HELOC Opportunities",
    "delete:opportunity_heloc": "Delete HELOC Opportunities",
    "read:opportunity_refinancing": "Read Refinancing Opportunities",
    "create:opportunity_refinancing": "Create Refinancing Opportunities",
    "update:opportunity_refinancing": "Update Refinancing Opportunities",
    "delete:opportunity_refinancing": "Delete Refinancing Opportunities",
    "read:opportunity_seller": "Read Seller Opportunities",
    "create:opportunity_seller": "Create Seller Opportunities",
    "update:opportunity_seller": "Update Seller Opportunities",
    "delete:opportunity_seller": "Delete Seller Opportunities",
    "create:employee": "Create New Employees",
    "delete:employee": "Delete Employees",
    "read:employee_overall": "View Overall's Employee Tab",
    "update:employee_overall": "Edit Overall's Employee Tab",
    "read:employee_contact": "View Contact's Employee Tab",
    "create:employee_notes": "Create Notes in Employees",
    "update:employee_notes": "Edit Notes in Employees",
    "import:employee_document": "Upload Documents in Employee",
    "delete:employee_notes": "Delete Notes in Employees",
    "delete:employee_document": "Delete Documents in Employee",
    "read:employee_commissions": "View Commissions' Employee Tab",
    "update:employee_commissions": "Edit Commissions' Employee Tab",
    "create:campaign_bulk_messages": "Create Bulk Messages",
    "read:campaign_bulk_messages": "View Bulk Messages",
    "read:campaign": "View Campaigns",
    "create:campaign": "Create Campaigns",
    "update:campaign": "Edit Campaigns",
    "delete:campaign": "Delete Campaigns",
    "create:user": "Create New Users",
    "read:user": "View Users",
    "update:user": "Edit Users",
    "delete:user": "Delete Users",
    "reassign:user": "Reassign Users",
    "update:user_role_permissions": "Edit Users' Roles and Permissions",
    "update:user_password": "Edit Users' Passwords",
    "create:calendar_appointments": "Create Appointments",
    "update:calendar_appointments": "Edit Appointments",
    "delete:calendar_appointments": "Delete Appointments",
    "create:calendar_appointments_other": "Assign Appointments to Others",
    "create:calendar_appointments_superior": "Assign Appointments to Superior Roles",
    "create:calendar_appointments_inferior": "Assign Appointments to Inferior Roles",
    "read:calendar_appointments_assigned_by": "View Appointments Assigned by",
    "create:calendar_tasks": "Create Tasks",
    "update:calendar_tasks": "Edit Tasks",
    "delete:calendar_tasks": "Delete Tasks",
    "create:calendar_tasks_other": "Assign Tasks to Others",
    "create:calendar_tasks_superior": "Assign Tasks to Superior Roles",
    "create:calendar_tasks_inferior": "Assign Tasks to Inferior Roles",
    "read:calendar_tasks_assigned_by": "View Tasks Assigned by",
    "read:settings_dropdowns": "View Settings Dropdowns",
    "read:settings_round_robin": "View Settings Round Robin",
    "read:settings_creditors": "View Settings Creditors",
    "read:settings_cr_pricing": "View Settings CR Pricing",
    "read:settings_anual_interest": "View Settings Anual Interest",
    "update:settings_dropdowns": "Edit Settings Dropdowns",
    "update:settings_round_robin": "Edit Settings Round Robin",
    "update:settings_creditors": "Edit Settings Creditors",
    "update:settings_cr_pricing": "Edit Settings CR Pricing",
    "update:settings_anual_interest": "Edit Settings Anual Interest",
    "read:settings_legal_texts": "View Settings Terms & Privacy",
    "update:settings_legal_texts": "Edit Settings Terms & Privacy",
    "read:settings_roles": "View Settings Roles",
    "update:settings_roles": "Edit Settings Roles",
    "read:referral_agent": "Read Referral Agents",
    "create:referral_agent": "Create Referral Agents",
    "update:referral_agent": "Update Referral Agents",
    "delete:referral_agent": "Delete Referral Agents",
    "read:tutorial_tab": "View Tutorials Tab",
    "read:tutorial": "View Tutorials",
    "create:tutorial": "Create Tutorials",
    "update:tutorial": "Update Tutorials",
    "delete:tutorial": "Delete Tutorials",
    "read:analytics_tab": "View Analytics Tab",
    "read:analytics": "View Analytics",
    "create:analytics": "Create Analytics",
    "update:analytics": "Update Analytics",
    "delete:analytics": "Delete Analytics",
    "read:business": "View Businesses",
    "create:business": "Create Businesses",
    "update:business": "Update Businesses",
    "delete:business": "Delete Businesses",
    "read:business_bank_information": "Unlock Business Bank Information",
    "read:business_document": "View Documents' Business Tab",
    "create:business_document": "Upload Documents in Businesses",
    "update:business_document": "Update Documents in Businesses",
    "delete:business_document": "Delete Documents in Businesses",
    "read:business_notes": "View Notes' Business Tab",
    "create:business_notes": "Create Notes in Businesses",
    "update:business_notes": "Edit Notes in Businesses",
    "delete:business_notes": "Delete Notes on Businesses",
    "read:business_voe": "View VOE's Business Tab",
    "view:credit_sales_analytics": "View Credit Sales Analytics",
    "view:telemarketing_analytics": "View Telemarketing Analytics",
    "view:ads_analytics": "View Ads Analytics",
    "view:re_commissions_analytics": "View RE Commissions Analytics",
    "read:pause_xp_stages": "Read Pause XP Table",
    "complete:pause_xp_stage": "Complete Pause XP Stage",
    "read:payments_tab": "View Payments Tab",
    "read:payments": "View Payments",
    "create:payments": "Create Payments",
    "update:payments": "Update Payments",
    "delete:payments": "Delete Payments",
    "read:teamhub_tab": "View Team Hub Tab",
    "read:teamhub_templates": "View Templates",
    "read:teamhub_all_templates": "View Other Users Templates",
    "create:teamhub_folders": "Create Folders",
    "update:teamhub_folders": "Edit Folders",
    "delete:teamhub_folders": "Delete Folders",
    "create:teamhub_system_templates": "Create System Templates",
    "update:teamhub_system_templates": "Edit System Templates",
    "delete:teamhub_system_templates": "Delete System Templates",
    "create:teamhub_own_templates": "Create Own Templates",
    "update:teamhub_own_templates": "Edit Own Templates",
    "delete:teamhub_own_templates": "Delete Own Templates",
    "create:teamhub_team_templates": "Create Team Templates",
    "update:teamhub_team_templates": "Edit Team Templates",
    "delete:teamhub_team_templates": "Delete Team Templates",
    "read:teamhub_schedule_and_holidays": "Access Schedule and Holidays",
    "read:teamhub_calendar": "View Calendar",
    "create:teamhub_calendar": "Create Calendar Entries",
    "update:teamhub_calendar": "Edit Calendar Entries",
    "delete:teamhub_calendar": "Delete Calendar Entries",
    "read:teamhub_schedules": "View Schedules",
    "create:teamhub_schedules": "Create Schedules",
    "update:teamhub_schedules": "Edit Schedules",
    "delete:teamhub_schedules": "Delete Schedules",
    "read:teamhub_vacations": "View Vacations",
    "create:teamhub_vacations": "Create Vacations",
    "update:teamhub_vacations": "Edit Vacations",
    "delete:teamhub_vacations": "Delete Vacations",
    "read:teamhub_holidays": "View Holidays",
    "create:teamhub_holidays": "Create Holidays",
    "update:teamhub_holidays": "Edit Holidays",
    "delete:teamhub_holidays": "Delete Holidays",
    "read:teamhub_live_attendance": "View Live Attendance",
    "read:teamhub_timecard_report": "View Time Card Reports",
    "read:teamhub_tools": "Access Tools",
    "read:teamhub_tools_rdc_credit_cost_closer": "RDC Credit Cost Closer",
    "read:teamhub_tickets": "Access Tickets",
    "update:teamhub_tickets": "Manage Tickets",

    // Shared — Lead & Client
    "read:properties": "View Properties",
    "create:properties": "Create Properties",
    "update:properties": "Edit Properties",
    "delete:properties": "Delete Properties",
};

/**
 * Flat permissions array for Schedule and Holidays module
 * Used in TEAMHUB_PERMISSIONS section and permission dependency maps
 */
export const SCHEDULE_PERMISSIONS = [
    PERMISSIONS.TEAMHUB_CALENDAR_READ,
    PERMISSIONS.TEAMHUB_CALENDAR_CREATE,
    PERMISSIONS.TEAMHUB_CALENDAR_UPDATE,
    PERMISSIONS.TEAMHUB_CALENDAR_DELETE,
    PERMISSIONS.TEAMHUB_SCHEDULES_READ,
    PERMISSIONS.TEAMHUB_SCHEDULES_CREATE,
    PERMISSIONS.TEAMHUB_SCHEDULES_UPDATE,
    PERMISSIONS.TEAMHUB_SCHEDULES_DELETE,
    PERMISSIONS.TEAMHUB_VACATIONS_READ,
    PERMISSIONS.TEAMHUB_VACATIONS_CREATE,
    PERMISSIONS.TEAMHUB_VACATIONS_UPDATE,
    PERMISSIONS.TEAMHUB_VACATIONS_DELETE,
    PERMISSIONS.TEAMHUB_HOLIDAYS_READ,
    PERMISSIONS.TEAMHUB_HOLIDAYS_CREATE,
    PERMISSIONS.TEAMHUB_HOLIDAYS_UPDATE,
    PERMISSIONS.TEAMHUB_HOLIDAYS_DELETE,
];

/**
 * Permissions for Shared (Lead & Client) section
 */
export const SHARED_PERMISSIONS = {
    sections: [
        {
            title: "Properties",
            permissions: [
                PERMISSIONS.READ_PROPERTIES,
                PERMISSIONS.CREATE_PROPERTIES,
                PERMISSIONS.UPDATE_PROPERTIES,
                PERMISSIONS.DELETE_PROPERTIES,
            ],
        },
    ],
};
